module.exports = __webpack_public_path__ + "img/sun state hemp.f45eb56d.png";